import { render, staticRenderFns } from "./dice-draw-result.vue?vue&type=template&id=19785a39&scoped=true&"
import script from "./dice-draw-result.vue?vue&type=script&lang=js&"
export * from "./dice-draw-result.vue?vue&type=script&lang=js&"
import style0 from "./dice-draw-result.vue?vue&type=style&index=0&id=19785a39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19785a39",
  null
  
)

export default component.exports